import { useState, useCallback } from 'react';

export const useUIState = () => {
    const [showPreview, setShowPreview] = useState(false);
    const [showSettings, setShowSettings] = useState(true);
    const [showHelp, setShowHelp] = useState(false);

    const togglePreview = useCallback(() => {
        setShowPreview(prev => !prev);
    }, []);

    const toggleSettings = useCallback(() => {
        setShowSettings(prev => !prev);
    }, []);

    const toggleHelp = useCallback(() => {
        setShowHelp(prev => !prev);
    }, []);

    return {
        showPreview,
        showSettings,
        showHelp,
        togglePreview,
        toggleSettings,
        toggleHelp
    };
}; 